import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=04d66ed6&scoped=true&"
import script from "./sidebar.vue?vue&type=script&lang=babel&"
export * from "./sidebar.vue?vue&type=script&lang=babel&"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=04d66ed6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d66ed6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItem,VListItemContent,VListItemTitle})
